import { render, staticRenderFns } from "./ChannelPluginStyle.vue?vue&type=template&id=139e7e74&"
import script from "./ChannelPluginStyle.vue?vue&type=script&lang=js&"
export * from "./ChannelPluginStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports